import React from 'react';
import PropTypes from 'prop-types';
import CartItem from './CartItem';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
class CartItemsList extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    getEditCartItemPath: PropTypes.func,
    removeItemFromCart: PropTypes.func,
    handleClose: PropTypes.func,
    currentCartPath: PropTypes.string
  };
  static defaultProps = {
    data: []
  };
  render() {
    const {
      data,
      getEditCartItemPath,
      removeItemFromCart,
      handleClose,
      currentCartPath
    } = this.props;
    return (
      <Box component={List} disablePadding data-testid="cart-items-list">
        {data.map(item => {
          return (
            <ListItem key={item.id} disableGutters divider>
              <CartItem
                {...item}
                editCartItemPath={getEditCartItemPath(item.id)}
                remove={() => removeItemFromCart(item.id)}
                handleClose={handleClose}
                currentCartPath={currentCartPath}
              />
            </ListItem>
          );
        })}
      </Box>
    );
  }
}

export default CartItemsList;
